import { render, staticRenderFns } from "./ECommerceShop.vue?vue&type=template&id=a6f23462&scoped=true"
import script from "./ECommerceShop.vue?vue&type=script&lang=js"
export * from "./ECommerceShop.vue?vue&type=script&lang=js"
import style0 from "./ECommerceShop.vue?vue&type=style&index=0&id=a6f23462&prod&lang=scss"
import style1 from "./ECommerceShop.vue?vue&type=style&index=1&id=a6f23462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f23462",
  null
  
)

export default component.exports